import bbobHTML from '@bbob/html'
import { preTransformBBCode } from './pre-transform-bb-code'
import { preset } from './preset'

export function bbCodeToPlaintext(bbCode: string): string {
  const preTransformedBbCode = preTransformBBCode(bbCode)
  const transformedBbCode = bbobHTML(preTransformedBbCode, preset())

  const el = document.createElement('div')
  el.innerHTML = transformedBbCode

  return el.innerText
}
